import * as Yup from "yup";

const DefaultSeoSchema = Yup.object().shape({
  meta_title: Yup.string().required("Please enter a title").strict().trim(),
  meta_desc: Yup.string(),
  seo_image: Yup.string(),
});

export default DefaultSeoSchema;
